import { render, staticRenderFns } from "./PageShows.vue?vue&type=template&id=09cca9e4&"
import script from "./PageShows.vue?vue&type=script&lang=js&"
export * from "./PageShows.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports